import { render, staticRenderFns } from "./DataFilter.vue?vue&type=template&id=ffb9b7dc&scoped=true&"
import script from "./DataFilter.vue?vue&type=script&lang=js&"
export * from "./DataFilter.vue?vue&type=script&lang=js&"
import style0 from "./DataFilter.vue?vue&type=style&index=0&id=ffb9b7dc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb9b7dc",
  null
  
)

export default component.exports